var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column justify-content-center vh-100 text-center"},[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){return _vm.generateListNumber()}}},[_vm._v("Generate Numbers")])])
}
var staticRenderFns = []

export { render, staticRenderFns }